import React from "react";
import GovernanceLinkNav from "../components/GovernanceLinkNav";
import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import PdfPointer from "../components/PdfPointer";
import Footer from "../components/Footer";
import LinedLinks from "../components/Navigation/LinedLinks";
import TestingSidebar from "../components/Navigation/TestingSidebar";

const FinancialStatement = () => {
  const pdfs = [
    {
      label: `القوائم المالية النهائية لجمعية جزيرة دارين 2023م`,
      url:
        "pdfs/financial_statement/the_final_financial_statements_of_the_darien_island_association_2023.pdf",
      size: '391 KB'
    },
    {
      label: 'القوائم المالية النهائية لجمعية جزيرة دارين 2022م',
      url:
        "pdfs/financial_statement/darien_island_association_final_financial_statements_2022.pdf",
      size: '403 KB'
    },
  ];
  return (
    <>
      <HeaderOriginal />
      <StickyNavBar />
      {/* <TestingSidebar /> */}
      <section className="pb-4 md:pb-10 pt-4 md:pt-10">
        <div className="max-w-screen-xl mx-auto px-3">
          <h1 className="text-primary font-bold text-center mt-4">
            القوائم المالية
          </h1>
          <LinedLinks link={'/financial_statements'} label={'القوائم المالية'}/>
          <div className="mt-8">
            {pdfs.map((pdf, index) => (
              <PdfPointer key={index}
                data={pdf}
              />
            ))}
          </div>
        </div>
      </section>
      <Footer/>
    </>
  );
};

export default FinancialStatement;
